import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { GruposService, Grupo } from 'src/app/services/admin/grupos/grupos.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-grupo-form',
  templateUrl: './grupo-form.component.html',
  styleUrls: ['./grupo-form.component.scss']
})
export class GrupoFormComponent implements OnInit {

  @Input() grupo: Grupo | null = null;
  @Output() guardar = new EventEmitter<Grupo>();
  @Output() cancelar = new EventEmitter<void>();

  form: FormGroup;
  loading = false;
  isNew = true;

  // Días de la semana
  diasSemana = [
    { label: 'Lunes', value: 'lun' },
    { label: 'Martes', value: 'mar' },
    { label: 'Miércoles', value: 'mie' },
    { label: 'Jueves', value: 'jue' },
    { label: 'Viernes', value: 'vie' },
    { label: 'Sábado', value: 'sab' },
    { label: 'Domingo', value: 'dom' }
  ];

  constructor(
    private fb: FormBuilder,
    private gruposService: GruposService
  ) { }

  ngOnInit(): void {
    this.isNew = !this.grupo;
    this.initForm();
    if (!this.isNew && this.grupo) {
      this.cargarDatos(this.grupo);
    }
  }

  initForm(): void {
    this.form = this.fb.group({
      des_grupo_cliente: ['', [Validators.required, Validators.minLength(3)]],
      desde: ['00:00', Validators.required],
      hasta: ['23:59', Validators.required],
      lun: [false],
      mar: [false],
      mie: [false],
      jue: [false],
      vie: [false],
      sab: [false],
      dom: [false]
    });
  }

  cargarDatos(grupo: Grupo): void {
    this.form.patchValue({
      des_grupo_cliente: grupo.des_grupo_cliente,
      desde: grupo.desde ? grupo.desde.substring(0, 5) : '00:00',
      hasta: grupo.hasta ? grupo.hasta.substring(0, 5) : '23:59',
      lun: grupo.lun,
      mar: grupo.mar,
      mie: grupo.mie,
      jue: grupo.jue,
      vie: grupo.vie,
      sab: grupo.sab,
      dom: grupo.dom
    });
  }

  selectearTodo(): void {
    const state = !this.allDaysSelected();
    this.diasSemana.forEach(dia => {
      this.form.get(dia.value).setValue(state);
    });
  }

  allDaysSelected(): boolean {
    return this.diasSemana.every(dia => this.form.get(dia.value).value);
  }

  limpiarHorarios(): void {
    this.form.patchValue({
      desde: '00:00',
      hasta: '23:59'
    });
  }

  guardarForm(): void {
    if (this.form.invalid) {
      Swal.fire('Error', 'Por favor completa todos los campos requeridos', 'error');
      return;
    }

    const formValue = this.form.value;

    // Convertir tiempo a formato HH:MM:SS
    const desde = `${formValue.desde}:00`;
    const hasta = `${formValue.hasta}:00`;

    const grupoData: Grupo = {
      des_grupo_cliente: formValue.des_grupo_cliente,
      desde,
      hasta,
      lun: formValue.lun,
      mar: formValue.mar,
      mie: formValue.mie,
      jue: formValue.jue,
      vie: formValue.vie,
      sab: formValue.sab,
      dom: formValue.dom
    };

    this.guardar.emit(grupoData);
  }

  cancelarForm(): void {
    this.cancelar.emit();
  }
}
